import type { RawMqttMessage } from '@/lib/mqtt/types';
import { useDataStreamStore } from '@/lib/store/dataStream';

const EMPTY: RawMqttMessage[] = [];

/** Messages for the selected topic + the currently selected message. */
export function useTopicMessages(): {
  messages: RawMqttMessage[];
  selected: RawMqttMessage | null;
  selectedMsgId: string | null;
} {
  const selectedTopic = useDataStreamStore((s) => s.selectedTopic);
  const selectedMsgId = useDataStreamStore((s) => s.selectedMsgId);
  const selectedMsg = useDataStreamStore((s) => s.selectedMsg);
  const messages = useDataStreamStore((s) =>
    selectedTopic ? (s.buffers.get(selectedTopic) ?? EMPTY) : EMPTY,
  );
  // Only the explicitly pinned message is "selected" (held in the store so it
  // survives ring eviction at high message rates). No fallback to the newest —
  // selecting a topic leaves the detail pane empty until a message is clicked.
  const selected = selectedMsg ?? null;
  return { messages, selected, selectedMsgId };
}
